import type { ReactElement } from 'react';
import { ErrorScreen } from '@kiwicom/account-components';

const onSystemError = (): ReactElement => {
  return <ErrorScreen />;
};

export default onSystemError;
